export default "__VITE_ASSET__nJzCYIjq__"